import { render, staticRenderFns } from "./Relatório.vue?vue&type=template&id=fc252580&scoped=true"
import script from "./Relatório.vue?vue&type=script&lang=js"
export * from "./Relatório.vue?vue&type=script&lang=js"
import style1 from "./Relatório.vue?vue&type=style&index=1&id=fc252580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc252580",
  null
  
)

export default component.exports